// extracted by mini-css-extract-plugin
export var buttonDiv = "pagination-module--buttonDiv--cced5";
export var buttonLink = "pagination-module--buttonLink--5aa2a";
export var figureDiv = "pagination-module--figureDiv--947dd";
export var figureDivSelected = "pagination-module--figureDivSelected--858fa";
export var figureLink = "pagination-module--figureLink--90d54";
export var link = "pagination-module--link--07e9b";
export var paginationH6 = "pagination-module--paginationH6--86b6e";
export var rootDiv = "pagination-module--rootDiv--3bab9";